/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC } from 'react';
import { Icon } from '../../../globalUtils/globalIcons';
import './TroubleShootingRowCard.css';
import { CustomTooltipWithLabel } from '../../../globalUtils/globalExports';

export interface IAlarmRowCard {
    row: IRmsSupportTroubleshootingAlarmListItem | null;
}

const TroubleShootingRowCard: FC<IAlarmRowCard> = (props) => {
    const rowData = props?.row;

    const getMaxWidth = (count: number) => {
    if (count <= 1) return '100%';
    if (count === 2) return '45%';
    if (count === 3) return '25%';
    return '22%'; 
    };
    const productCount = rowData?.productTypes?.length ?? 0;

    const maxWidth = getMaxWidth(productCount);
        const productTypeList = rowData?.productTypes?.map(productType=>{
    let backgroundColor = '';
    let color = '';
    let borderColor = '';
    switch(productType) {
                            case 'Harmony Gen1.0':
                            color = '#713EFF';
                            backgroundColor = '#E1E1FF';
                            borderColor = '#713EFF7A'
                            break;
                        case 'EVM150':
                            color = '#128FED';
                            backgroundColor = '#E5F3FE';
                            borderColor = '#128FED7A'
                            break;
                        case 'Harmony Gen2.0':
                            color = '#E6901F';
                            backgroundColor = '#FCF5DB';
                            borderColor = '#E6901F7A'
                            break;
                    }
                    return (
                        <span key={productType}
                        style={
                            {
                                color,
                                backgroundColor,
                                border: `1px solid ${borderColor}`,
                                fontSize: '12px',
                                letterSpacing:'-1.6%',
                                borderRadius: '6px',
                                padding:'2px 4px',
                               maxWidth
                            }
                        }
                        >
                    <CustomTooltipWithLabel label= {productType} labelId='charging__station-notes' />
                    </span>
                    )
                })
    return (
        <div className='trouble-shooting-detail-list-conatiner'>
                <div  className='trouble-shooting-detail-list-card'>
                    <div className='trouble-shooting-detail-info-card'>
                        <div className='trouble-shooting-detail-header-row'>
                            <div className='trouble-shooting-detail-alarm-info'>
                                <span className='trouble-shooting-detail-list-severity'>
                                    <Icon iconClassName={`rms__icon rms__icon ${rowData?.severity?.toLowerCase()}__alarm__icon`} />
                                </span>

                                <span className='trouble-shooting-detail-list-alarm'>
                                 <CustomTooltipWithLabel label= {rowData?.alarm || 'NA'} labelId='charging__station-notes' />
                                </span>
                                <div className='trouble-shooting-product-label-row' >
                                {productTypeList}
                                </div>
                            </div>

                            <div className='trouble-shooting-detail-error-info'>
                                <span className='trouble-shooting-detail-list-signal'>
                                    
                                    <span className='trouble-shooting-detail-list-signal-value'>
                                        
                                    <CustomTooltipWithLabel label={'Error Code : ' + rowData?.errorCode} labelId='charging__station-notes' />
                                    </span>
                                </span>
                                <span className='trouble-shooting-detail-vendor-error'>
                                    <span className='trouble-shooting-detail-vendor-error-value'>
                                <CustomTooltipWithLabel label={'Vendor Error Code : ' + rowData?.vendorErrorCode} labelId='charging__station-notes' />
                                    </span>
                                </span>
                            </div>
                        </div>

                        <div className='trouble-shooting-detail-alarm-description'>
                              <CustomTooltipWithLabel label= {rowData?.description || 'NA'} labelId='charging__station-notes' />
                        </div>
                    </div>

                    <div className='trouble-shooting-detail-action-card'>
                        <div className='trouble-shooting-detail-action-heading'>L1 Action:</div>
                        <div className='trouble-shooting-detail-action-description'>{rowData?.l1Action}</div>
                    </div>

                </div>
        </div>
    );
};

export default TroubleShootingRowCard;
